<template>
  <div>
    <div class="strong">{{widget.label || widget.id}}</div>

    <div class="hover-shadow box-border-7" style="padding:5px;margin-top:5px;">
      <div v-if="!segments || segments.length < 1"
        style="color:#EEE;font-size:20px;">没有...</div>

      <span v-for="e in segments"
        class="segment-span"
        :key="e">{{e}}</span>
    </div>
  </div>
</template>

<script>
export default {
    name: 'TicketWidgetSegment',

    props : ["widget"],

    data() {
      return {
        segments: []
      };
    },

    methods: {
      onLoad_0() {
        var _this = this;
        sdk.TicketApi().ticketSegment({
          ticketNo: _this.$route.query.orderId
        }).then(res => {
          _this.segments = res || [];
        }, err => {
          console.log('#36 TicketApi listRelatedTicket ticket_not_visible', err);

          if ( 'ticket_not_visible' == err ) {
            _message('TicketApi.ticketSegment 你没有权限查看这个工单 ' + _this.$route.query.orderId);
            return;
          }
        });
      }
    },

    mounted() {
      this.onLoad_0();
    }
}
</script>

<style>
  .segment-span {
    display: inline-block;
    padding: 1px 5px;
    margin: 1px;

    background-color: #f4f4f5;

    border-radius: 2px;
    border-color: #e9e9eb;
    border-width: 1px;
    border-style: solid;

    color: #909399;
  }
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketWidgetSegment.vue